import React, { FC } from "react";
import normalizeCardExpirationDate from "../inputMasks/normalizeCardExpirationDate";
import TextInput from "../TextInput/TextInput";
import Model, { IModel } from "../../../Utility/Model/Model";
import { ITextInputProps } from "../TextInput/TextInput.interface";

export interface ICreditCardExpDateInputProps
  extends ITextInputProps,
    Pick<IModel, "onModelChange"> {}

const CreditCardExpDateInput: FC<ICreditCardExpDateInputProps> = ({
  value,
  onChange: originalOnChange,
  onModelChange,
  ...inputProps
}) => {
  return (
    <Model
      value={value}
      parser={normalizeCardExpirationDate}
      onChange={originalOnChange}
      onModelChange={onModelChange}
      {...inputProps}
    >
      {({ parsedValue: _parsedValue, formattedValue, onChange, ...rest }) => (
        <TextInput
          label="Expiration Date"
          value={formattedValue}
          placeholder="MM/YY"
          type="tel"
          autoComplete="cc-exp"
          onChange={onChange}
          {...rest}
        />
      )}
    </Model>
  );
};

export default CreditCardExpDateInput;
